export default __webpack_public_path__ + "static/media/coder.460eb43a.png";